import { cn } from '@/shared/utils';

export type TagProps = React.PropsWithChildren<{
	type: 'info' | 'warning' | 'success' | 'error' | 'default';
	withBorder?: boolean;
	disabled?: boolean;
	as?: 'div' | 'span';
	className?: string;
}>;

export function Tag({
	type,
	withBorder = false,
	as: Component = 'div',
	className,
	...props
}: TagProps) {
	return (
		<Component
			className={cn(
				{
					'bg-indigo/10 text-indigo': type === 'info',
					'bg-yellow/10 text-yellow': type === 'warning',
					'bg-green-50 text-green-500': type === 'success',
					'bg-red-500/10 text-red-600': type === 'error',
					'bg-gray-1/10 text-gray-1': type === 'default',
					'border border-indigo/50': withBorder && type === 'info',
					'border border-yellow/50': withBorder && type === 'warning',
					'border border-green-500/50': withBorder && type === 'success',
					'border border-red-500/50': withBorder && type === 'error',
					'border border-gray-1/50': withBorder && type === 'default',
				},
				'flex items-center gap-1 whitespace-nowrap rounded-lg px-2 py-1 text-sm',
				className,
			)}
			{...props}
		/>
	);
}
